import React, { useEffect } from 'react';
import { Tabs, Tab, Box, Button, Alert } from '@mui/material';
import InsuranceTable from '../components/views/InsuranceTable';
import LoanTable from '../components/views/LoanTable';
import RentTable from '../components/views/RentTable';
import BillTable from '../components/views/BillTable';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import bg from '../assets/banner.jpg';

function ViewAllPage() {
  const [value, setValue] = React.useState(0);
  const [message, setMessage] = React.useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if tab index is passed in the location state
    if (location.state && typeof location.state.tab === 'number') {
      setValue(location.state.tab);
    }
    // Check for success message
    if (location.state?.message) {
      setMessage(location.state.message);
      const timer = setTimeout(() => setMessage(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate('/view-all', { state: { tab: newValue } });
  };

  return (
    <Box display="flex">
      <Sidebar />
      <Box
        flexGrow={1}
        ml={30}
        sx={{
          minHeight: '100vh',
          backgroundImage: `url(${bg})`,
          backgroundAttachment: 'fixed',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          p: 4,
          color: '#fff',
          overflowY: 'auto',
        }}
      >
        {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="inherit"
          TabIndicatorProps={{
            style: { backgroundColor: '#e0b256' },
          }}
          sx={{
            backgroundColor: 'rgba(0,0,0,0.5)',
            borderRadius: 2,
            mb: 3,
          }}
        >
          <Tab label="Insurance Policies" />
          <Tab label="Loan Payments" />
          <Tab label="Rent Payments" />
          <Tab label="Bills & Cards" />
        </Tabs>

        <Box
          sx={{
            backgroundColor: 'rgba(0,0,0,0.5)',
            borderRadius: 2,
            p: 3,
          }}
        >
          {value === 0 && <InsuranceTable />}
          {value === 1 && <LoanTable />}
          {value === 2 && <RentTable />}
          {value === 3 && <BillTable />}
        </Box>

        <Button
          variant="outlined"
          onClick={() => navigate('/dashboard')}
          sx={{
            mt: 3,
            color: '#fff',
            borderColor: '#fff',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.1)',
              borderColor: '#fff',
            },
          }}
        >
          Back to Dashboard
        </Button>
      </Box>
    </Box>
  );
}

export default ViewAllPage;
